<template>
    <div>
        <banet-modal-confirm
            @confirmNo="confirm(false)"
            @confirmYes="confirm(true)"
            :show="showConfirm"
            :showFooter="true"
            :title="getTranslation('modal_confirm_title')"
            :body="getTranslation('label_confirm_user_delete')">
        </banet-modal-confirm>
        <h2 v-if="!hideTitle">{{ getTranslation('lbl_userlist_headline') }}</h2>
        <div class="well">
            <div class="row">
                <div class="col-md-2 col-sm-4">
                    <form id="search" style="position: relative; z-index: 0;">
                        <div class="input-group">
                            <span class="input-group-addon glyphicon glyphicon-search" aria-hidden="true"
                                  :title="getTranslation('lbl_search')"></span>
                            <input name="query" v-model="searchQuery"
                                   class="form-control" :placeholder="getTranslation('lbl_search')">
                            <span class="input-group-addon">
                                <button class="btn btn-default" @click.prevent="searchQuery = ''">
                                    <span class="glyphicon glyphicon-remove"></span>
                                </button>
                            </span>
                        </div>
                    </form>
                </div>
                <div class="col-md-10 col-sm-8">
                    <router-link to="/history/user" activeClass="active" tag="button"
                                 class="btn btn-primary pull-right"
                                 :title="getTranslation('lbl_history_deleted')">
                        <i class="fa fa-history" aria-hidden="true"></i>
                    </router-link>
                    <router-link :to="`/adduser/${isClientSubPage ? client._id : '' }`" activeClass="active" tag="button" class="btn btn-default pull-right">
                        {{ getTranslation('app_lbl_action_user_create') }}</router-link>
                </div>
            </div>
        </div>
        <banet-tablegrid
                :data="fullGridData"
                :columns="gridColumns"
                :filter-key="searchQuery"
                :actionCol="true"
                :editBtn="true"
                :deleteBtn="true"
                :actionLink="'/user'"
                :history="'/history/user'"
                @delete="userDelete">
        </banet-tablegrid>
    </div>
</template>

<script>
    import { mainEventBus } from '../../../../main';
    import {userMixin} from '../../../../Banet/mixins/userMixin.js';
    import {translationMixin} from '../../../../Banet/mixins/translationMixin.js';
    import BanetTablegrid from '../../../../Banet/components/BanetTablegrid.vue';
    import {alertMixin} from '../../../../Banet/mixins/alertMixin.js';
    import BanetModalConfirm from '../../../../Banet/errorsAndNotifications/BanetModalConfirm.vue';
    export default {
        props: ['client', 'hideTitle', 'isClientSubPage'],
        mixins: [ userMixin, translationMixin, alertMixin ],
        sockets: {
            usersChanged: function(){
                this.getUsers();
            }
        },
        components: {
            banetTablegrid: BanetTablegrid,
            banetModalConfirm: BanetModalConfirm
        },
        data: function(){
            return {
                searchQuery: '',
                gridColumns: [], //, {custom:{
//                    label: 'Actions',
//                    action: 'goto',
//                    order: false,
//                    key: '_id'
//                }}],
                gridData: [],
                selectedUser: {},
               appUser: false,
               clientUser: false
            }
        },
        created: function(){
            this.calculateClient();
        },
        computed: {
            fullGridData: function(){
               let gridData = [];
               if( this.loggedRole === 'client'){
                  gridData = this.gridData;
               } else if(this.appUser && this.clientUser){
                  mainEventBus['clientUser'] = true;
                  mainEventBus['appUser'] = true;
                  gridData = this.gridData;
               } else if(this.appUser && !this.clientUser){
                    mainEventBus['clientUser'] = false;
                    mainEventBus['appUser'] = true;
                    const store = this.$store;
                    gridData = this.gridData.filter(function(row){
                        return (row.role && row.role !== 'client-admin' && row.email !== store.state.user.email) ? row : false;
                    });
               } else if(this.clientUser && !this.appUser){
                    mainEventBus['clientUser'] = true;
                    mainEventBus['appUser'] = false;
                    // gridData = this.gridData.filter(function(row){
                    //     return (row.role && row.role === 'client-admin') ? row : false;
                    // });
                   gridData = this.gridData;
               } else if (!this.appUser && !this.clientUser) {
//                  this.appUser = true;
                  gridData = [];
               }
               return gridData;
            }
        },
        watch: {
            translations: function() {
                this.gridColumns = [
                    { label: this.getTranslation('lbl_email'), value: 'email' }, 
                    { label: this.getTranslation('lbl_username'), value: 'username' },
                    { label: this.getTranslation('lbl_user_first_name'), value: 'firstName' },
                    { label: this.getTranslation('lbl_user_last_name'), value: 'lastName' },
                    { label: this.getTranslation('lbl_user_role'), value: 'role' }
                ];
                if(this.loggedRole === 'client' || this.loggedRole === 'user') {
                   this.gridColumns.splice(-1, 1);
                }
            }
        },
        methods: {
            calculateClient() {
                if(this.client) {
                    this.clientUser = true;
                    this.appUser = false;
                } else {
                    this.clientUser = false;
                    if( this.isAdmin){
                        this.appUser = true;
                    }
                }
                /*if(typeof mainEventBus['appUser'] !== 'undefined') { this.clientUser = mainEventBus['appUser']; }
                if(typeof mainEventBus['clientUser'] !== 'undefined') { this.clientUser = mainEventBus['clientUser']; }*/
                this.getUsers();
            },
            getUsers: function(){
                const url = (this.isClientSubPage) ? `user/${this.client._id}/list` : 'user';
                console.log('GETUSERS: ', url);
                this.$http.get(url).then(res => {
                    this.gridData = res.data.obj;
                }, res => {
                    // error callback
                    console.log('Error happend')
                });
            },
            userDelete: function(user){
                this.selectedUser = user;
                this.showConfirm = true;
            },
            confirm: function(y){
                this.showConfirm = false;
                if(y){
                    this.deleteConfirmed = true;
                    this.$socket.emit('userDelete', this.selectedUser);
//                    this.deleteUser(this.selectedUser);
                    this.selectedUser = {};
                } else {
                    this.deleteConfirmed = false;
                    this.selectedUser = {};
                    return false;
                }
            },
           setFilterAppUser(event){
//               console.log(event);
//              mainEventBus['appUser'] = appUser;
           },
           setFilterClientUser(clientUser){
              mainEventBus['clientUser'] = clientUser;
           }
        }
    }
</script>



// WEBPACK FOOTER //
// UserList.vue?371e071c